/**
 * File: NotificationsBridge.tsx
 * Path: apps/admin/src/modules/layout/components/NotificationsBridge.tsx
 * Description: Runs once inside the signed-in admin, rendering nothing:
 *
 * - refreshes this browser's push token if notifications are on here
 *   (stale tokens are how notifications silently stop, iPhones especially);
 * - follows a tapped notification to its page without a reload (sw.js posts
 *   `idk:navigate` to the open window);
 * - keeps the app icon's badge at the unread count where supported.
 */

import { useNotificationsBridgeController } from "@/modules/layout/hooks/useNotificationsBridgeController";

export const NotificationsBridge: React.FC = () => {
  useNotificationsBridgeController();
  return null;
};
